// extracted by mini-css-extract-plugin
export default {"Wrapper":"AccreditationsView_Wrapper__BG8QF"};